import { render, staticRenderFns } from "./TourItem.vue?vue&type=template&id=9845106e&scoped=true&"
import script from "./TourItem.vue?vue&type=script&lang=js&"
export * from "./TourItem.vue?vue&type=script&lang=js&"
import style0 from "./TourItem.vue?vue&type=style&index=0&id=9845106e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9845106e",
  null
  
)

export default component.exports